export default "__VITE_ASSET__5s3_ORGT__"